import createAsyncActionType from '../utilities/createAsyncActionType';

export const GET_NATIONALITIES = createAsyncActionType('GET_NATIONALITIES');


// WEBPACK FOOTER //
// ./src/types/nationalityTypes.js